import { env } from "@/lib/environment";

export interface Client {
  id: string;
  name: string;
  logo: string;
  industry: string;
  description?: string;
}

export const CLIENTS: Client[] = [
  {
    id: "amazon",
    name: "Amazon",
    logo: env.NEXT_PUBLIC_CDN_URL + "/images/clients/amazon.svg",
    industry: "E-commerce & Technology",
    description: "Global e-commerce and technology leader",
  },
  {
    id: "mercedes-benz",
    name: "Mercedes-Benz",
    logo: env.NEXT_PUBLIC_CDN_URL + "/images/clients/mercedes-benz.svg",
    industry: "Automotive & Luxury",
    description: "Premium automotive manufacturer",
  },
  {
    id: "nec",
    name: "NEC",
    logo: env.NEXT_PUBLIC_CDN_URL + "/images/clients/nec.svg",
    industry: "Technology & Electronics",
    description: "Global technology and electronics corporation",
  },
  {
    id: "unilever",
    name: "Unilever",
    logo: env.NEXT_PUBLIC_CDN_URL + "/images/clients/uniliver.svg",
    industry: "Consumer Goods",
    description: "Multinational consumer goods company",
  },
  {
    id: "etisalat",
    name: "Etisalat",
    logo: env.NEXT_PUBLIC_CDN_URL + "/images/clients/etisalat.svg",
    industry: "Telecommunications",
    description: "Leading telecommunications provider",
  },
  {
    id: "decathlon",
    name: "Decathlon",
    logo: env.NEXT_PUBLIC_CDN_URL + "/images/clients/decathlon.svg",
    industry: "Sports & Retail",
    description: "International sporting goods retailer",
  },
  {
    id: "myntra",
    name: "Myntra",
    logo: env.NEXT_PUBLIC_CDN_URL + "/images/clients/myntra.svg",
    industry: "Fashion & E-commerce",
    description: "Leading fashion e-commerce platform",
  },
  {
    id: "cult-fit",
    name: "Cult.fit",
    logo: env.NEXT_PUBLIC_CDN_URL + "/images/clients/cult-fit.svg",
    industry: "Fitness & Wellness",
    description: "Digital fitness and wellness platform",
  },
  {
    id: "embassy",
    name: "Embassy",
    logo: env.NEXT_PUBLIC_CDN_URL + "/images/clients/embassy.svg",
    industry: "Real Estate",
    description: "Premium real estate developer",
  },
  {
    id: "asian-paints",
    name: "Asian Paints",
    logo: env.NEXT_PUBLIC_CDN_URL + "/images/clients/asian-paint.svg",
    industry: "Manufacturing & Chemicals",
    description: "Leading paint and coatings manufacturer",
  },
  {
    id: "uber",
    name: "Uber",
    logo: env.NEXT_PUBLIC_CDN_URL + "/images/clients/uber.svg",
    industry: "Transportation & Technology",
    description: "Global ride-sharing and mobility platform",
  },
  {
    id: "manipal",
    name: "Manipal Hospitals",
    logo: env.NEXT_PUBLIC_CDN_URL + "/images/clients/manipal.svg",
    industry: "Healthcare",
    description: "Leading healthcare provider",
  },
  {
    id: "tata-trusts",
    name: "Tata Trusts",
    logo: env.NEXT_PUBLIC_CDN_URL + "/images/clients/tata-trust.svg",
    industry: "Philanthropy & Social Impact",
    description: "Philanthropic organization",
  },
  {
    id: "namdharis-fresh",
    name: "Namdharis Fresh",
    logo: env.NEXT_PUBLIC_CDN_URL + "/images/clients/namdharis_fresh.svg",
    industry: "Agriculture & Food",
    description: "Fresh produce and organic foods",
  },
  {
    id: "burjeel-hospital",
    name: "Burjeel Hospital",
    logo: env.NEXT_PUBLIC_CDN_URL + "/images/clients/burjeel-hospital.svg",
    industry: "Healthcare",
    description: "Premium healthcare services",
  },
  {
    id: "asian-hospital",
    name: "Asian Hospital",
    logo: env.NEXT_PUBLIC_CDN_URL + "/images/clients/asian-hospital.svg",
    industry: "Healthcare",
    description: "Specialized healthcare services",
  },
  {
    id: "c-wj",
    name: "C&WJ",
    logo: env.NEXT_PUBLIC_CDN_URL + "/images/clients/c&wj.svg",
    industry: "Manufacturing",
    description: "Industrial manufacturing company",
  },
  {
    id: "hgs",
    name: "HGS",
    logo: env.NEXT_PUBLIC_CDN_URL + "/images/clients/hgs.svg",
    industry: "Business Process Outsourcing",
    description: "Global business process management",
  },
  {
    id: "olive-hospital",
    name: "Olive Hospital",
    logo: env.NEXT_PUBLIC_CDN_URL + "/images/clients/olivehospital.svg",
    industry: "Healthcare",
    description: "Comprehensive healthcare solutions",
  },
  {
    id: "dlf",
    name: "DLF",
    logo: env.NEXT_PUBLIC_CDN_URL + "/images/clients/dlf.svg",
    industry: "Real Estate",
    description: "Leading real estate developer",
  },
];

export function getFeaturedClients(): Client[] {
  return CLIENTS;
}

export function getClientsByIndustry(industry: string): Client[] {
  return CLIENTS.filter(client => client.industry.toLowerCase().includes(industry.toLowerCase()));
}

export function getClientById(id: string): Client | undefined {
  return CLIENTS.find(client => client.id === id);
}
